import { Component, EventEmitter, OnInit, OnChanges, Input, Output, ViewChild, ElementRef } from "@angular/core";
// [[Providers]]
import { CollectiveMarketplaceCartService } from "~services/collective/client/marketplace/cart/cart.service";
import { ClientMarketplaceCartProductService } from "~services/collective/client/marketplace/cart/product/product.service";
import { CustomerWishlistService } from "~services/panel/client/marketplace/customer/wishlist/wishlist.service";
// ]
@Component({
  selector: "IncluceProductBuyInline",
  templateUrl: "./component.html",
  styleUrls: ["./component.css"],
})
export class ThisComponent implements OnInit {
  @Input() cart: any;
  @Input() product: any;

  hide_this_box: boolean = false;
  constructor(public collectiveMarketplaceCartService: CollectiveMarketplaceCartService, public clientMarketplaceCartProductService: ClientMarketplaceCartProductService, public customerWishlistService: CustomerWishlistService) {}

  /**
   * on init
   */
  ngOnInit() {}

  /**
   * on changes
   */
  ngOnChanges() {
    this.createComponent();
  }

  /**
   * Creates component
   */
  createComponent() {}

  /**
   * Gets cart
   */
  getCart() {
    /**
     * Cart
     *
     * Request inicial do CARRINHO para acompanhamento nas Páginas.
     */
    this.collectiveMarketplaceCartService.cart({ client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid }).subscribe((Cart: any) => {
      if (Cart != null) {
        this.collectiveMarketplaceCartService.setCart(Cart.data);
      }
    });
  }

  productHasBeenBought: any = false;
  /**
   * Clients marketplace cart product service create
   */
  clientMarketplaceCartProductServiceCreate() {
    var _ = this.clientMarketplaceCartProductService.store({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
      client_marketplace_core_product_id: this.product.id,
      inventory_quantity: this.inventoryQuantity,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.productHasBeenBought = true;
          this.getCart();
        },
        () => {}
      );
    }
  }

  inventoryQuantity: any = 1;
  clientMarketplaceCartProductQuantityChange($event: any) {
    this.inventoryQuantity = $event.target.value;
  }

  /**
   * Scrolls into view
   */
  scrollIntoView() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }
}
